<template>

  <div>

    <a-row type="flex" align="middle" >
      <a-col :span="24" class="mapGeo-single-white">.</a-col>
      <a-col :span="20">
        <a-input v-model="keyWord" placeholder="请输入要搜索的地址" />
      </a-col>
      <a-col :span="2" :offset="1">
        <a-button  @click="setPlace">搜索</a-button>
      </a-col>

      <a-col :span="24" class="mapGeo-single-white">.</a-col>
      <a-col :span="2" >
        <label>经度</label>
      </a-col>
      <a-col :span="7">
        <a-input v-model="longitude" />
      </a-col>

      <a-col :span="2" :offset="1">
        <label>纬度</label>
      </a-col>
      <a-col :span="8">
        <a-input v-model="latitude" />
      </a-col>

      <a-col :span="2" :offset="1">
        <a-button @click="SavePoint"  type="primary">确定</a-button>
      </a-col>




    </a-row>
    <a-divider />
    <baidu-map
      class="map"
      @ready="handler"
      style="height: 500px;"
      :center="center"
      :zoom="15"
      :map-click="false">
      <div>
        <bm-marker
          :dragging="true"
          animation="BMAP_ANIMATION_BOUNCE"
          :position="center"
          @dragend="dragend"
        >
        </bm-marker>
      </div>

    </baidu-map>


  </div>

</template>

<script>

  export default {

    data(){
      return {
        map: null,
        local:null,
        center: {},
        mk: null,
        latitude: '',
        longitude: '',
        loading:false
      }
    },
    props:{
      keyWord:{
        default:'',
        type:String
      }
    },
    created () {
      this.setPlace();
    },
    mounted(){

    },
    methods: {
      SavePoint(){
        let that=this;
        this.$emit('mapgeoEvent',{longitude:that.longitude,latitude:that.latitude,})

      },
      setPlace(){
        this.local = new BMap.LocalSearch(this.map, {
          onSearchComplete: this.searchPlace
        })
        console.log(this.keyWord)
        console.log(this.local)
        this.local.search(this.keyWord)
      },
      handleMarker(obj, point) {
        obj.mk = new BMap.Marker(point)
        obj.map.addOverlay(obj.mk)
        obj.mk.enableDragging() // 可拖拽
        obj.mk.addEventListener('dragend', function(e) { // 监听标注的拖拽，获取拖拽后的经纬度
          this.latitude = point.lat
          this.longitude =  point.lng
        })
        obj.map.panTo(point)
      }
      ,
      searchPlace() {
        let that=this;
        if (that.local.getResults() != undefined) {
          that.map.clearOverlays() //清除地图上所有覆盖物
          if (that.local.getResults().getPoi(0)) {
            let point = that.local.getResults().getPoi(0).point //获取第一个智能搜索的结果
            that.map.centerAndZoom(point, 18)
            that.handleMarker(that, point)

            that.latitude = point.lat
            that.longitude =  point.lng

          } else {
            that.$message.error('未匹配到地点!')
          }
        } else {

        }

      }
      ,
      handler: function ({ BMap, map }) {
        map.enableScrollWheelZoom(true)
        map.centerAndZoom('中国', 13)

        const _this = this
        const geolocation = new BMap.Geolocation()
        const hide = _this.$message.loading('正在获取当前省市请稍候..', 0)
        geolocation.getCurrentPosition(function (r) {

          setTimeout(hide, 1000)
          _this.center = {


            lng:_this.$store.getters.User.enterprise.cLongitude,
            lat: _this.$store.getters.User.enterprise.cLatitude
          }
          //_this.autoLocationPoint = { lng: r.longitude, lat: r.latitude }        // 自定义覆盖物
          _this.initLocation = true
        }, { enableHighAccuracy: true })

        window.map = map
        // 赋值，方便调用，本节被用到
        this.BMap = BMap
        this.map = map

      },
      // 拖动结束后
      dragend (e) {
        this.position = e.point
        const _this = this

        const gc = new this.BMap.Geocoder()
        gc.getLocation(e.point, function (rs) {
          console.log(rs)
          // var addComp = rs.addressComponents
          // this.addr = addComp.province + ', ' + addComp.city + ', ' + addComp.district + ', ' + addComp.street + ', ' + addComp.streetNumber
          _this.addr = rs.address
        })
      }


    },
    watch:{
      keyWord:{
        handler(val,oldval){
          this.setPlace();
          this.searchPlace();
        },
        deep:true
      }
    }

  }
</script>
<style lang="less" scoped>
  /* 样式自己看心情写吧 */
  .mapGeo-single-input-box{
    display: flex;
  }
  .mapGeo-single-white{
    color:#ffffff
  }
</style>
